import OrganisationForm from '@/components/pages/InformationPortal/Organisation/OrganisationForm/OrganisationForm.vue'
export default {
    name: 'AddOrganisation',
    components: {OrganisationForm}
}